import React from "react";
import "./projects.scss";
import { FiFolder } from "react-icons/fi";
import { FiGithub } from "react-icons/fi";
import "aos/dist/aos.css";

const Projects = () => {
  return (
    <section>
      <div className="container card-container" id="projects">
        <div className="proj-header">
          <h1 data-aos="fade-up">/Projects</h1>
        </div>
        <div className="card-deck">
          {/* Autonomous Robot */}
          <div className="card" data-aos="fade-up">
            <div className="card-header">
              <div className="folder">
                <FiFolder />
              </div>
              <div className="git-share">
                <a
                  href="https://github.com/sofiasawczenko/autonomous_robot_computer_vision"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FiGithub />
                </a>
              </div>
            </div>
            <div className="card-body">
              <h5 className="card-title">Autonomous Robot</h5>
              <p className="card-text">
                Capable of navigating independently through an environment using
                computer vision techniques to detect obstacles and make
                navigation decisions. The robot uses Raspberry Pi and Arduino.
              </p>
            </div>
            <div className="card-footer tech-tags">
              <span>Electronics</span>
              <span>Python</span>
              <span>C++</span>
            </div>
          </div>

          {/* Chatbot with RAG */}
          <div className="card" data-aos="fade-up">
            <div className="card-header">
              <div className="folder">
                <FiFolder />
              </div>
              <div className="git-share">
                <a
                  href="https://github.com/sofiasawczenko/chatbot_rag_langchain_openai"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FiGithub />
                </a>
              </div>
            </div>
            <div className="card-body">
              <h5 className="card-title">Chatbot with RAG</h5>
              <p className="card-text">
                Development of a console-based chatbot using Retrieval Augmented
                Generation (RAG) with LangChain and OpenAI’s LLM. The chatbot
                answers questions based on PDFs stored in a folder.
              </p>
            </div>
            <div className="card-footer tech-tags">
              <span>RAG</span>
              <span>LangChain</span>
              <span>OpenAI</span>
            </div>
          </div>

          {/* Heart Failure Prediction */}
          <div className="card" data-aos="fade-up">
            <div className="card-header">
              <div className="folder">
                <FiFolder />
              </div>
              <div className="git-share">
                <a
                  href="https://github.com/sofiasawczenko/heart_failure_forecasting/tree/main"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FiGithub />
                </a>
              </div>
            </div>
            <div className="card-body">
              <h5 className="card-title">
                Heart Failure Prediction with Supervised Learning
              </h5>
              <p className="card-text">
                Prediction project for heart failure using a Kaggle dataset,
                data preprocessing techniques, and validation through logistic
                regression.
              </p>
            </div>
            <div className="card-footer tech-tags">
              <span>Python</span>
              <span>Logistic Regression</span>
            </div>
          </div>

          {/* Weather Forecasting */}
          <div className="card" data-aos="fade-up">
            <div className="card-header">
              <div className="folder">
                <FiFolder />
              </div>
              <div className="git-share">
                <a
                  href="https://github.com/sofiasawczenko/weather_forecasting"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FiGithub />
                </a>
              </div>
            </div>
            <div className="card-body">
              <h5 className="card-title">Weather Forecasting</h5>
              <p className="card-text">
                Forecast of weather conditions using linear regression and ridge
                regression techniques based on historical climate data from New
                York.
              </p>
            </div>
            <div className="card-footer tech-tags">
              <span>Python</span>
              <span>Linear Regression</span>
              <span>Ridge Regression</span>
            </div>
          </div>

          {/* House Price Forecasting */}
          <div className="card" data-aos="fade-up">
            <div className="card-header">
              <div className="folder">
                <FiFolder />
              </div>
              <div className="git-share">
                <a
                  href="https://github.com/sofiasawczenko/forecasting_house_price"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FiGithub />
                </a>
              </div>
            </div>
            <div className="card-body">
              <h5 className="card-title">House Price Forecasting</h5>
              <p className="card-text">
                Development of a machine learning model to predict the average
                price of houses in Boston using data analysis and regression
                techniques.
              </p>
            </div>
            <div className="card-footer tech-tags">
              <span>Python</span>
              <span>Polynomial Regression</span>
            </div>
          </div>

          {/* Sales Trend Analysis */}
          <div className="card" data-aos="fade-up">
            <div className="card-header">
              <div className="folder">
                <FiFolder />
              </div>
              <div className="git-share">
                <a
                  href="https://github.com/sofiasawczenko/sales_time_series_analysis"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FiGithub />
                </a>
              </div>
            </div>
            <div className="card-body">
              <h5 className="card-title">
                Sales Trend Analysis with Time Series Forecasting
              </h5>
              <p className="card-text">
                Sales data analysis to identify trends and make forecasts using
                time series methods in Python with libraries such as pandas and
                seaborn.
              </p>
            </div>
            <div className="card-footer tech-tags">
              <span>Pandas</span>
              <span>Seaborn</span>
              <span>Matplotlib</span>
            </div>
          </div>

          {/* Employee Data ETL Pipeline */}
          <div className="card" data-aos="fade-up">
            <div className="card-header">
              <div className="folder">
                <FiFolder />
              </div>
              <div className="git-share">
                <a
                  href="https://github.com/sofiasawczenko/ETL_employee_info_pipeline"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FiGithub />
                </a>
              </div>
            </div>
            <div className="card-body">
              <h5 className="card-title">Employee Sensitive Data ETL Pipeline</h5>
              <p className="card-text">
                ETL pipeline to process sensitive employee data using Google
                Cloud Data Fusion, Cloud Composer, and BigQuery, focusing on
                efficiency and security.
              </p>
            </div>
            <div className="card-footer tech-tags">
              <span>Python</span>
              <span>GCP</span>
              <span>Google Data Fusion</span>
            </div>
          </div>

          {/* Game Stats ETL */}
          <div className="card" data-aos="fade-up">
            <div className="card-header">
              <div className="folder">
                <FiFolder />
              </div>
              <div className="git-share">
                <a
                  href="https://github.com/sofiasawczenko/ETL_game_match_stats"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FiGithub />
                </a>
              </div>
            </div>
            <div className="card-body">
              <h5 className="card-title">Game Statistics ETL Pipeline</h5>
              <p className="card-text">
                Pipeline to process and analyze cricket match statistics using
                Google Cloud services (GCP), such as Cloud Functions and Cloud
                Dataflow.
              </p>
            </div>
            <div className="card-footer tech-tags">
              <span>Python</span>
              <span>GCP</span>
              <span>Cloud Functions</span>
            </div>
          </div>

          {/* Sudoku Solver */}
          <div className="card" data-aos="fade-up">
            <div className="card-header">
              <div className="folder">
                <FiFolder />
              </div>
              <div className="git-share">
                <a
                  href="https://github.com/sofiasawczenko/sudoku"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FiGithub />
                </a>
              </div>
            </div>
            <div className="card-body">
              <h5 className="card-title">Sudoku Solver</h5>
              <p className="card-text">
                Java back-end to solve a Sudoku puzzle using the backtracking
                algorithm, offering an efficient solution to the problem.
              </p>
            </div>
            <div className="card-footer tech-tags">
              <span>Java</span>
              <span>Backtracking Algorithm</span>
            </div>
          </div>

          {/* Marketplace Web Scraping */}
          <div className="card" data-aos="fade-up">
            <div className="card-header">
              <div className="folder">
                <FiFolder />
              </div>
              <div className="git-share">
                <a
                  href="https://github.com/sofiasawczenko/meli_webscraping"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FiGithub />
                </a>
              </div>
            </div>
            <div className="card-body">
              <h5 className="card-title">Marketplace Product Web Scraping</h5>
              <p className="card-text">
                Product data scraping from marketplaces using Python,
                BeautifulSoup, and Requests, with SQLite database storage for
                further analysis.
              </p>
            </div>
            <div className="card-footer tech-tags">
              <span>Python</span>
              <span>BeautifulSoup</span>
              <span>Requests</span>
            </div>
          </div>

          {/* Sentiment Analysis */}
          <div className="card" data-aos="fade-up">
            <div className="card-header">
              <div className="folder">
                <FiFolder />
              </div>
              <div className="git-share">
                <a
                  href="https://github.com/sofiasawczenko/analyzing_text_sentiment"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FiGithub />
                </a>
              </div>
            </div>
            <div className="card-body">
              <h5 className="card-title">Text Sentiment Analysis</h5>
              <p className="card-text">
                Project that analyzes the sentiment of textual data using
                libraries like NLTK, TextBlob, and Newspaper3k for processing
                and article analysis.
              </p>
            </div>
            <div className="card-footer tech-tags">
              <span>NLTK</span>
              <span>TextBlob</span>
              <span>Newspaper3k</span>
            </div>
          </div>

          {/* Virtual Assistant */}
          <div className="card" data-aos="fade-up">
            <div className="card-header">
              <div className="folder">
                <FiFolder />
              </div>
              <div className="git-share">
                <a
                  href="https://github.com/sofiasawczenko/aiva_virtual_assistant_ai"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FiGithub />
                </a>
              </div>
            </div>
            <div className="card-body">
              <h5 className="card-title">Virtual Assistant Browser Extension</h5>
              <p className="card-text">
                AI-powered virtual assistant integrated into the browser to
                offer real-time personalized user assistance using Google Gemini
                API.
              </p>
            </div>
            <div className="card-footer tech-tags">
              <span>Java</span>
              <span>Gemini API</span>
              <span>React.js</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Projects;
